import CopyWebSvg from '@assets/images/svg/copy-web.svg';
import React from 'react';
import { View } from 'react-native';

export interface CopyWebIconProps {
    size?: number;
    color?: string;
}

/**
 * Web-safe variant of CopyIcon (no clipPath wrapper in the SVG).
 * See DumbbellWebIcon for details on the web clipPath id collision.
 */
export function CopyWebIcon({ size = 20, color = '#333333' }: Readonly<CopyWebIconProps>) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CopyWebSvg width={size} height={size} color={color} />
        </View>
    );
}

export default CopyWebIcon;
